import {
    CloudDownloadOutlined, PauseCircleOutlined, PlayCircleOutlined, SyncOutlined
} from '@ant-design/icons'
import { Button, notification, Popconfirm } from 'antd'
import { trackPromise, usePromiseTracker } from 'react-promise-tracker'
import { useData } from '../../../../data'


const JobActions = (props) => {

    const data = useData()
    const jobs = data.jobs()

    // Refresh the job page
    // const refreshJob = () => {
    //     props.refresh()
    // }

    // refresh this job details
    const refreshJob = () => {
        props.loadJob()
    }

    // Rerun failed tasks
    const pauseRuningJob = () => {
        if (props.job_id) {
            trackPromise(
                jobs.pauseJob(props.job_id)
                    .then(() => {
                        notification.success({
                            message: "Job Paused successfully."
                        })
                        refreshJob()
                    })
                    .catch(console.log), 'pause_job'
            )
        }
    }

    // Rerun failed tasks
    const runFailedTask = () => {
        if (props.job_id) {
            trackPromise(
                jobs.runFailedTask(props.job_id)
                    .then(() => {
                        notification.success({
                            message: "Job Restarted successfully."
                        })
                        refreshJob()
                    })
                    .catch(console.log), 'run_failed_task'
            )
        }
    }


    // Generate a download file 
    const generateDownload = () => {
        if (props.job_id) {
            trackPromise(
                jobs.generateOutputs(props.job_id)
                    .then(() => {
                        notification.success({
                            message: "Download Generator started successfully.",
                            description: "You will get a output file to download in a short time."
                        })
                        refreshJob()
                    })
                    .catch(console.log), 'generate_download'
            )
        }
    }


    // Run all tasks of the Job 
    const dispatchJob = () => {
        if (props.job_id) {
            trackPromise(
                jobs.dispatchJob(props.job_id)
                    .then(() => {
                        notification.success({
                            message: "Job started successfully."
                        })
                        refreshJob()
                    })
                    .catch(err => {
                        notification.error({
                            message: err.message,
                            description: "Failed to start the job"
                        })

                        console.log(err.message)
                    }


                    )
            )
        }
    }

    // Re-run email collection spider
    const reRunEmailCollection = () => {
        if (props.job_id) {
            trackPromise(
                jobs.reRunEmailCollection(props.job_id)
                    .then(() => {
                        notification.success({
                            message: "Email collection spider restarted successfully."
                        })
                        refreshJob()
                    })
            )
        }
    }

    // Re-run email collection spider
    const stopSpider = () => {
        if (props.job_id) {
            trackPromise(
                jobs.stopSpider(props.job_id)
                    .then(() => {
                        notification.success({
                            message: "Spider stop signal sent successfully."
                        })
                        refreshJob()
                    })
            )
        }
    }


    // Re Scrape anly missing data
    const reRunJob = () => {
        if (props.job_id) {
            trackPromise(
                jobs.reRunJob(props.job_id)
                    .then(() => {
                        notification.success({
                            message: "Job ReRuned Successfully."
                        })
                        refreshJob()
                    })
                    .catch(err => {
                        notification.error({
                            message: err.message,
                            description: "Failed to start the job"
                        })

                        console.log(err)
                    }
                    ))
        }
    }

    const loading = usePromiseTracker({ area: 'refresh' }).promiseInProgress
    const pausingJob = usePromiseTracker({ area: 'pause_job' }).promiseInProgress
    const geenratingDonwloads = usePromiseTracker({ area: 'generate_download' }).promiseInProgress
    const dispatchJobLader = usePromiseTracker({ area: 'dispatch_job' }).promiseInProgress
    const runFailedTaskLoader = usePromiseTracker({ area: 'run_failed_task' }).promiseInProgress


    return (
        <>
            <Button style={{ marginLeft: 6 }} type="primary" icon={<SyncOutlined />} loading={loading} onClick={refreshJob}>Refresh</Button>

            {(['PROCESSING', 'PAUSED'].includes(props.job.status)) &&
                <Popconfirm
                    title="Are you sure?"
                    onConfirm={pauseRuningJob}
                    okText="Yes"
                    cancelText="No"
                >
                    <Button
                        style={{ marginLeft: 6 }}
                        type="primary"
                        icon={(props.job.status == 'PROCESSING') ? <PauseCircleOutlined /> : <PlayCircleOutlined />}
                        loading={pausingJob}
                    >
                        {(props.job.status == 'PROCESSING') ? 'Pause' : 'Resume'}
                    </Button>
                </Popconfirm>
            }


            {(props.job.status == 'PENDING') &&
                <Popconfirm
                    title="Are you sure to run the job?"
                    onConfirm={dispatchJob}
                    okText="Yes"
                    cancelText="No"
                >
                    <Button style={{ marginLeft: 6 }} type="primary" icon={<PlayCircleOutlined />} loading={dispatchJobLader}>
                        Start
                    </Button>
                </Popconfirm>
            }

            {(props.job.status == 'DONE') &&
                <Popconfirm
                    title="Are you sure to run the job?"
                    onConfirm={reRunJob}
                    okText="Yes"
                    cancelText="No"
                >
                    <Button style={{ marginLeft: 6 }} type="primary" icon={<PlayCircleOutlined />} loading={dispatchJobLader}>
                        Rerun Job
                    </Button>
                </Popconfirm>
            }

            {/* {(props.job.tool_category == 'contact') &&
                <Popconfirm
                    title="Are you sure to re-run email collection spider of the job?"
                    onConfirm={reRunEmailCollection}
                    okText="Yes"
                    cancelText="No"
                >
                    <Button style={{ marginLeft: 6 }} type="primary" icon={<PlayCircleOutlined />} loading={dispatchJobLader}>
                        Rerun Email Collection
                    </Button>
                </Popconfirm>
            } */}

            {(['PROCESSING', 'PAUSED'].includes(props.job.status)) &&
                <Popconfirm
                    title="Are you sure to stop spider of the job?"
                    onConfirm={stopSpider}
                    okText="Yes"
                    cancelText="No"
                >
                    <Button style={{ marginLeft: 6 }} type="primary" icon={<PlayCircleOutlined />} loading={dispatchJobLader}>
                        Stop
                    </Button>
                </Popconfirm>
            }

            {/* <Popconfirm
                title="Are you sure to run failed tasks?"
                onConfirm={runFailedTask}
                okText="Yes"
                cancelText="No"
            >
                <Button style={{marginLeft: 6}} type="primary" icon={<RedoOutlined />} loading={runFailedTaskLoader}> Run Failed Task </Button>
            </Popconfirm> */}

            <Popconfirm
                title="Are you sure to generate donwnload?"
                onConfirm={generateDownload}
                okText="Yes"
                cancelText="No"
            >
                <Button style={{ marginLeft: 6 }} type="primary" icon={<CloudDownloadOutlined />} loading={geenratingDonwloads}> Generate Output </Button>
            </Popconfirm>

        </>
    );
}

export default JobActions;